import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Question } from '../../../core/_models/question.model';
import { QuestionService } from "../../../core/_services/question.service";
import { NotificationService } from "../../../core/_services/notification.service";

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.sass']
})
export class QuestionComponent implements OnInit {

  public model: Question = null;
  public modelToBeSaved: Question = null;
  public isEditing = false;
  public isDeleting = false;

  private _modelUuid: string = null;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _questionService: QuestionService,
    private _router: Router,
    private _notificationService: NotificationService
  ) { }

  ngOnInit() {
    this._activatedRoute.params.subscribe(params => {
      if(params['uuid']) {
        this.getModel(params['uuid']);
      } else {
        this.model = null;
        this._modelUuid = null;
        this.changeMode('edit');
      }
    });
  }

  getModel(modelUuid: string) {
    this._questionService.get(modelUuid)
      .subscribe((model) => {
        this.model = model;
        this._modelUuid = model.uuid;
        this.changeMode('view');
      }, () => {
        this._router.navigate(['/panel/not-found']);
      });
  }

  changeMode(mode: 'view' | 'edit') {
    if (mode == 'view') {
      if (!this._modelUuid) {
        this._router.navigate(['/panel/questions']);
      }
      this.isEditing = false;
    }
    if (mode == 'edit') {
      this.isEditing = true;
    }
  }

  saveModel() {
    if (this.modelToBeSaved) {
      if (this.modelToBeSaved.uuid) {
        this._questionService.update(this.modelToBeSaved.uuid, this.modelToBeSaved).subscribe((model) => {
          this.getModel(model.uuid);
          this.changeMode('view');
          this._notificationService.success("Saved");
        }, (error) => {
          console.error(error);
          this._notificationService.error("Error");
        });
      } else {
        this._questionService.create(this.modelToBeSaved).subscribe((model) => {
          this._notificationService.success("Saved");
          this._router.navigate(['/panel/question', {uuid: model.uuid}]);
        }, (error) => {
          console.error(error);
          this._notificationService.error("Error");
        });
      }
    }
  }

  deleteModel() {
    this.isDeleting = true;
  }

  onModelDeleted(shouldDelete: boolean = false) {
    this.isDeleting = false;
    if (shouldDelete) {
      if (this._modelUuid) {
        this._questionService.delete(this._modelUuid).subscribe(() => {
          this._notificationService.success("Deleted");
          this._router.navigate(['/panel/questions']);
        }, (error) => {
          console.error(error);
          this._notificationService.error("Error");
        });
      } else {
        this._router.navigate(['/panel/questions']);
      }
    }
  }

  onModelChanged(modelToBeSaved: Question) {
    if (modelToBeSaved) {
      this.modelToBeSaved = modelToBeSaved;
      this.modelToBeSaved.uuid = this._modelUuid;
    } else {
      this.modelToBeSaved = null;
    }

  }

}
